// extracted by mini-css-extract-plugin
export var fadePop = "IconLinks-module--fade-pop--2eafe";
export var growHeightIn = "IconLinks-module--grow-height-in--e67be";
export var label = "IconLinks-module--label--0f539";